<div class="z-20 items-center" #confirmButton>
  <div class="relative">
    @if (!treeViewDataService.$employeeView() && this.employeeDataService.hasChangedSinceLastConfirmed()) {
      <span data-testid="orangeCircle" class="indicator indicator-primary indicator-pos size-4"></span>
    }
  </div>

  <div class="items-center">
    <button (click)="toggleDialog()" [attr.data-testId]="'toggle-confirmation-dialog-btn'" class="btn btn-ghost btn-square border">
      @if (treeViewDataService.$employeeView()) {
        <ng-icon name="heroInformationCircle" color="dark:white" size="22"></ng-icon>
      } @else {
        <ng-icon name="heroPaperAirplane" color="dark:white" size="22"></ng-icon>
      }
    </button>
  </div>

  @if (showDialog) {
    <div class="relative w-full">
      <div
        class="absolute w-[370px] z-9999 p-3 right-0 min-w-min top-5 rounded-sm border border-grey-400 dark:border-grey-300 shadow-lvl1 dark:shadow-none bg-white dark:bg-grey-800 text-grey-600 dark:text-grey-200 float-right"
      >
        @if (treeViewDataService.$employeeView(); as foreignEmployee) {
          <div data-testid="lastConfirmed-text-management">
            @let lastConfirmed = foreignEmployee.lastConfirmed;

            @if (!lastConfirmed) {
              {{ foreignEmployee.firstname }} {{ foreignEmployee.lastname }} hat Skills und Zertifikate noch nie bestätigt
            } @else {
              {{ foreignEmployee.firstname }} {{ foreignEmployee.lastname }} hat Skills und Zertifikate zuletzt bestätigt: am
              {{ lastConfirmed | date: 'dd.MM.yyyy' }} um {{ lastConfirmed | date: 'HH:mm' }} Uhr
            }
          </div>
        } @else {
          <h3>Skills und Zertifikate bestätigen</h3>

          <div class="pt-3 space-y-2" data-testid="explanation-text">
            <p>Bitte bestätige, dass Deine Skills und Zertifikate aktuell und vollständig sind.</p>
            <p>
              Du kannst sie jederzeit erneut bestätigen. Aktuelle Skills und Zertifikate helfen bei Ausschreibungen, der persönlichen
              Weiterentwicklung, der Vernetzung im InterFace und vielem mehr.
            </p>
          </div>

          <div class="pt-3" data-testid="confirmation-button">
            <button
              class="btn btn-primary"
              [attr.data-testId]="'skills-certificate-confirmation-btn'"
              (click)="confirm()"
              (keydown.enter)="confirm()"
            >
              <ng-icon name="heroPaperAirplane" size="22"></ng-icon>
              Skills und Zertifikate bestätigen
            </button>
          </div>

          <div class="pt-3" data-testid="lastConfirmed-text">
            @let lastConfirmed = $safeNavigationMigration(employeeDataService.employee()?.lastConfirmed);
            @let hasChangedSinceLastConfirmed = employeeDataService.hasChangedSinceLastConfirmed();
            @if (!hasChangedSinceLastConfirmed) {
              Alles auf dem aktuellen Stand<br />
            }
            @if (lastConfirmed) {
              Zuletzt bestätigt am {{ lastConfirmed | date: 'dd.MM.yyyy' }} um {{ lastConfirmed | date: 'HH:mm' }} Uhr
            } @else {
              Noch nie bestätigt
            }
          </div>
        }
      </div>
    </div>
  }
</div>
